// manualData.js
export const MANUAL = {
  devices: [
    {
      id: 'android',
      name: {
        ru: 'Android',
        en: 'Android'
      },
      icon: 'fab fa-android',
      apps: [
        {
          id: 'android-v2raytun',
          name: {
            ru: 'v2raytun',
            en: 'v2raytun'
          },
          icon: 'V2',
          steps: [
            {
              number: 1,
              title: {
                ru: 'Скачайте v2raytun',
                en: 'Download v2raytun'
              },
              content: {
                ru: 'Скачайте приложение v2raytun из Google Play:',
                en: 'Download v2raytun app from Google Play:'
              },
              buttons: [
                {
                  text: {
                    ru: '📲 Google Play',
                    en: '📲 Google Play'
                  },
                  url: 'https://play.google.com/store/apps/details?id=com.v2raytun.android',
                  className: 'download-btn'
                }
              ],
              note: {
                title: {
                  ru: 'ℹ️ Важно',
                  en: 'ℹ️ Important'
                },
                content: {
                  ru: 'Важная информация: приложение безопасно, имеет более 1 000 000 скачиваний, а также огромное количество отзывов',
                  en: 'Important information: the app is safe, has over 1,000,000 downloads, and a huge number of reviews'
                }
              }
            },
            {
              number: 2,
              title: {
                ru: 'Перейдите по ссылке на подписку в профиле',
                en: 'Follow the subscription link in the profile'
              },
              content: {
                ru: 'Можно использовать пробный период на 30 дней',
                en: 'You can use a 30-day trial period.'
              },
              buttons: [
                {
                  text: {
                    ru: 'Открыть профиль',
                    en: 'Open profile'
                  },
                  url: 'https://diamondvpn.online/profile',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/instructions/getSub.png',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            },
            {
              number: 3,
              title: {
                ru: 'Добавьте подключение',
                en: 'Add connection'
              },
              content: {
                ru: 'После того, как вы нажмете "Моя подписка" у вас откроется сайт внутри телеграм. Вам нужно выбрать устройство (должно быть Android), выбрать приложение v2raytun и нажать "Добавить подписку". Приложение автоматически откроется и подписка добавится.',
                en: 'After clicking "My Subscription", a website will open inside Telegram. You need to select device (should be Android), select v2raytun app and click "Add Subscription". The app will open automatically and the subscription will be added.'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если подписка не добавляется, убедитесь, что вы установили приложение. При возникновении напишите в поддержку:',
                  en: 'If subscription is not added, make sure you installed the app. If issues occur, contact support:'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/android/v2/v2raytunsub.jpg',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            },
            {
              number: 4,
              title: {
                ru: 'Подключитесь к VPN',
                en: 'Connect to VPN'
              },
              content: {
                ru: 'Поздравляю! Если вы на этом шаге, значит вы добавили подписку. Выбирайте нужную локацию и подключайтесь!',
                en: 'Congratulations! If you are at this step, you have added the subscription. Choose your desired location and connect!'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если VPN не работает, обратитесь в поддержку:',
                  en: 'If VPN is not working, contact support:'
                }
              },
              note: {
                title: {
                  ru: 'Ограничения',
                  en: 'Limitations'
                },
                content: {
                  ru: 'У тестового периода ограничение: 5 дней и 15 гигабайт. У платных подписок дается 120 гигабайт в месяц (этого вполне достаточно, чтобы смотреть ютуб по 8+ часов ежедневно в Full HD). Данные ограничения нужны, чтобы недобросовестные пользователи не делились своими подписками со своими друзьями.',
                  en: 'Trial period limitations: 5 days and 15 gigabytes. Paid subscriptions get 120 gigabytes per month (this is enough to watch YouTube for 8+ hours daily in Full HD). These limitations are needed to prevent users from sharing subscriptions with friends.'
                }
              },
              images: [
                {
                  src: 'images/android/v2/v2raytuncon.jpg',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            }
          ]
        },
        {
          id: 'android-happ',
          name: {
            ru: 'Happ',
            en: 'Happ'
          },
          icon: 'HP',
          steps: [
            {
              number: 1,
              title: {
                ru: 'Скачайте Happ',
                en: 'Download Happ'
              },
              content: {
                ru: 'Скачайте приложение Happ из Google Play:',
                en: 'Download Happ app from Google Play:'
              },
              buttons: [
                {
                  text: {
                    ru: '📲 Google Play',
                    en: '📲 Google Play'
                  },
                  url: 'https://play.google.com/store/apps/details?id=com.happproxy',
                  className: 'download-btn'
                }
              ],
              note: {
                title: {
                  ru: 'ℹ️ Важно',
                  en: 'ℹ️ Important'
                },
                content: {
                  ru: 'Важная информация: приложение безопасно, имеет более 1 000 000 скачиваний, а также огромное количество отзывов',
                  en: 'Important information: the app is safe, has over 1,000,000 downloads, and a huge number of reviews'
                }
              }
            },
            {
              number: 2,
              title: {
                ru: 'Перейдите по ссылке на подписку в профиле',
                en: 'Follow the subscription link in the profile'
              },
              content: {
                ru: 'Можно использовать пробный период на 30 дней',
                en: 'You can use a 30-day trial period.'
              },
              buttons: [
                {
                  text: {
                    ru: 'Открыть профиль',
                    en: 'Open profile'
                  },
                  url: 'https://diamondvpn.online/profile',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/instructions/getSub.png',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            },
            {
              number: 3,
              title: {
                ru: 'Добавьте подключение',
                en: 'Add connection'
              },
              content: {
                ru: 'После того, как вы нажмете "Моя подписка" у вас откроется сайт внутри телеграм. Вам нужно выбрать устройство (должно быть Android), выбрать приложение Happ и нажать "Добавить подписку". Приложение автоматически откроется и подписка добавится.',
                en: 'After clicking "My Subscription", a website will open inside Telegram. You need to select device (should be Android), select Happ app and click "Add Subscription". The app will open automatically and the subscription will be added.'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если подписка не добавляется, убедитесь, что вы установили приложение. При возникновении напишите в поддержку:',
                  en: 'If subscription is not added, make sure you installed the app. If issues occur, contact support:'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/android/happ/happaddsub.jpg',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            },
            {
              number: 4,
              title: {
                ru: 'Подключитесь к VPN',
                en: 'Connect to VPN'
              },
              content: {
                ru: 'Поздравляю! Если вы на этом шаге, значит вы добавили подписку. Выбирайте нужную локацию и подключайтесь!',
                en: 'Congratulations! If you are at this step, you have added the subscription. Choose your desired location and connect!'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если VPN не работает, обратитесь в поддержку:',
                  en: 'If VPN is not working, contact support:'
                }
              },
              note: {
                title: {
                  ru: 'Ограничения',
                  en: 'Limitations'
                },
                content: {
                  ru: 'У тестового периода ограничение: 5 дней и 15 гигабайт. У платных подписок дается 120 гигабайт в месяц (этого вполне достаточно, чтобы смотреть ютуб по 8+ часов ежедневно в Full HD). Данные ограничения нужны, чтобы недобросовестные пользователи не делились своими подписками со своими друзьями.',
                  en: 'Trial period limitations: 5 days and 15 gigabytes. Paid subscriptions get 120 gigabytes per month (this is enough to watch YouTube for 8+ hours daily in Full HD). These limitations are needed to prevent users from sharing subscriptions with friends.'
                }
              },
              images: [
                {
                  src: 'images/android/happ/happconnect.jpg',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: 'ios',
      name: {
        ru: 'iOS',
        en: 'iOS'
      },
      icon: 'fab fa-apple',
      apps: [
        {
          id: 'ios-v2raytun',
          name: {
            ru: 'v2raytun',
            en: 'v2raytun'
          },
          icon: 'V2',
          steps: [
            {
              number: 1,
              title: {
                ru: 'Скачайте v2raytun',
                en: 'Download v2raytun'
              },
              content: {
                ru: 'Скачайте приложение v2raytun из App Store:',
                en: 'Download v2raytun app from App Store:'
              },
              buttons: [
                {
                  text: {
                    ru: '📲 App Store (RU)',
                    en: '📲 App Store (RU)'
                  },
                  url: 'https://apps.apple.com/ru/app/v2raytun/id6476628951',
                  className: 'download-btn'
                },
                {
                  text: {
                    ru: '📲 App Store (EU/US)',
                    en: '📲 App Store (EU/US)'
                  },
                  url: 'https://apps.apple.com/us/app/v2raytun/id6476628951',
                  className: 'download-btn'
                }
              ],
              note: {
                title: {
                  ru: 'ℹ️ Важно',
                  en: 'ℹ️ Important'
                },
                content: {
                  ru: 'Важная информация: приложение безопасно, имеет более 1 000 000 скачиваний, а также огромное количество отзывов',
                  en: 'Important information: the app is safe, has over 1,000,000 downloads, and a huge number of reviews'
                }
              }
            },
            {
              number: 2,
              title: {
                ru: 'Перейдите по ссылке на подписку в профиле',
                en: 'Follow the subscription link in the profile'
              },
              content: {
                ru: 'Можно использовать пробный период на 30 дней',
                en: 'You can use a 30-day trial period.'
              },
              buttons: [
                {
                  text: {
                    ru: 'Открыть профиль',
                    en: 'Open profile'
                  },
                  url: 'https://diamondvpn.online/profile',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/instructions/getSub.png',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            },
            {
              number: 3,
              title: {
                ru: 'Добавьте подключение',
                en: 'Add connection'
              },
              content: {
                ru: 'После того, как вы нажмете "Моя подписка" у вас откроется сайт внутри телеграм. Вам нужно выбрать устройство (должно быть iOS), выбрать приложение v2raytun и нажать "Добавить подписку". Приложение автоматически откроется и подписка добавится.',
                en: 'After clicking "My Subscription", a website will open inside Telegram. You need to select device (should be iOS), select v2raytun app and click "Add Subscription". The app will open automatically and the subscription will be added.'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если подписка не добавляется, убедитесь, что вы установили приложение. При возникновении напишите в поддержку:',
                  en: 'If subscription is not added, make sure you installed the app. If issues occur, contact support:'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/ios/v2/iosv2addsub.jpg',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            },
            {
              number: 4,
              title: {
                ru: 'Подключитесь к VPN',
                en: 'Connect to VPN'
              },
              content: {
                ru: 'Поздравляю! Если вы на этом шаге, значит вы добавили подписку. Выбирайте нужную локацию и подключайтесь!',
                en: 'Congratulations! If you are at this step, you have added the subscription. Choose your desired location and connect!'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если VPN не работает, обратитесь в поддержку:',
                  en: 'If VPN is not working, contact support:'
                }
              },
              note: {
                title: {
                  ru: 'Ограничения',
                  en: 'Limitations'
                },
                content: {
                  ru: 'У тестового периода ограничение: 5 дней и 15 гигабайт. У платных подписок дается 120 гигабайт в месяц (этого вполне достаточно, чтобы смотреть ютуб по 8+ часов ежедневно в Full HD). Данные ограничения нужны, чтобы недобросовестные пользователи не делились своими подписками со своими друзьями.',
                  en: 'Trial period limitations: 5 days and 15 gigabytes. Paid subscriptions get 120 gigabytes per month (this is enough to watch YouTube for 8+ hours daily in Full HD). These limitations are needed to prevent users from sharing subscriptions with friends.'
                }
              },
              images: [
                {
                  src: 'images/ios/v2/iosv2connect.jpg',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            }
          ]
        },
        {
          id: 'ios-happ',
          name: {
            ru: 'Happ',
            en: 'Happ'
          },
          icon: 'HP',
          steps: [
            {
              number: 1,
              title: {
                ru: 'Скачайте Happ',
                en: 'Download Happ'
              },
              content: {
                ru: 'Скачайте приложение Happ из App Store:',
                en: 'Download Happ app from App Store:'
              },
              buttons: [
                {
                  text: {
                    ru: '📲 App Store (RU)',
                    en: '📲 App Store (RU)'
                  },
                  url: 'https://apps.apple.com/ru/app/happ-proxy-utility-plus/id6746188973',
                  className: 'download-btn'
                },
                {
                  text: {
                    ru: '📲 App Store (EU/US)',
                    en: '📲 App Store (EU/US)'
                  },
                  url: 'https://apps.apple.com/us/app/happ-proxy-utility/id6504287215',
                  className: 'download-btn'
                }
              ],
              note: {
                title: {
                  ru: 'ℹ️ Важно',
                  en: 'ℹ️ Important'
                },
                content: {
                  ru: 'Важная информация: приложение безопасно, имеет более 1 000 000 скачиваний, а также огромное количество отзывов',
                  en: 'Important information: the app is safe, has over 1,000,000 downloads, and a huge number of reviews'
                }
              }
            },
            {
              number: 2,
              title: {
                ru: 'Перейдите по ссылке на подписку в профиле',
                en: 'Follow the subscription link in the profile'
              },
              content: {
                ru: 'Можно использовать пробный период на 30 дней',
                en: 'You can use a 30-day trial period.'
              },
              buttons: [
                {
                  text: {
                    ru: 'Открыть профиль',
                    en: 'Open profile'
                  },
                  url: 'https://diamondvpn.online/profile',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/instructions/getSub.png',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            },
            {
              number: 3,
              title: {
                ru: 'Добавьте подключение',
                en: 'Add connection'
              },
              content: {
                ru: 'После того, как вы нажмете "Моя подписка" у вас откроется сайт внутри телеграм. Вам нужно выбрать устройство (должно быть iOS), выбрать приложение Happ и нажать "Добавить подписку". Приложение автоматически откроется и подписка добавится.',
                en: 'After clicking "My Subscription", a website will open inside Telegram. You need to select device (should be iOS), select Happ app and click "Add Subscription". The app will open automatically and the subscription will be added.'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если подписка не добавляется, убедитесь, что вы установили приложение. При возникновении напишите в поддержку:',
                  en: 'If subscription is not added, make sure you installed the app. If issues occur, contact support:'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/ios/happ/ioshappaddsub.jpg',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            },
            {
              number: 4,
              title: {
                ru: 'Подключитесь к VPN',
                en: 'Connect to VPN'
              },
              content: {
                ru: 'Поздравляю! Если вы на этом шаге, значит вы добавили подписку. Выбирайте нужную локацию и подключайтесь!',
                en: 'Congratulations! If you are at this step, you have added the subscription. Choose your desired location and connect!'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если VPN не работает, обратитесь в поддержку:',
                  en: 'If VPN is not working, contact support:'
                }
              },
              note: {
                title: {
                  ru: 'Ограничения',
                  en: 'Limitations'
                },
                content: {
                  ru: 'У тестового периода ограничение: 5 дней и 15 гигабайт. У платных подписок дается 120 гигабайт в месяц (этого вполне достаточно, чтобы смотреть ютуб по 8+ часов ежедневно в Full HD). Данные ограничения нужны, чтобы недобросовестные пользователи не делились своими подписками со своими друзьями.',
                  en: 'Trial period limitations: 5 days and 15 gigabytes. Paid subscriptions get 120 gigabytes per month (this is enough to watch YouTube for 8+ hours daily in Full HD). These limitations are needed to prevent users from sharing subscriptions with friends.'
                }
              },
              images: [
                {
                  src: 'images/ios/happ/ioshappconnect.jpg',
                  alt: {
                    ru: 'Скриншот приложения',
                    en: 'App screenshot'
                  },
                  className: 'step-image',
                  style: { maxWidth: '300px' }
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: 'windows',
      name: {
        ru: 'Windows',
        en: 'Windows'
      },
      icon: 'fab fa-windows',
      apps: [
        {
          id: 'windows-koala',
          name: {
            ru: 'Koala Clash',
            en: 'Koala Clash'
          },
          icon: 'KC',
          steps: [
            {
              number: 1,
              title: {
                ru: 'Скачайте Koala Clash',
                en: 'Download Koala Clash'
              },
              content: {
                ru: 'Перейдите на сайт Koala Clash по кнопке и скачайте последнюю версию для Windows:',
                en: 'Go to Koala Clash website via the button and download the latest version for Windows:'
              },
              buttons: [
                {
                  text: {
                    ru: '📲 Ссылка на Koala Clash',
                    en: '📲 Link to Koala Clash'
                  },
                  url: 'https://github.com/coolcoala/clash-verge-rev-lite/releases',
                  className: 'download-btn'
                }
              ],
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Обязательно у версии должно быть написано Latest! Листайте ниже, пока не увидите версию для Windows. Если что то не получается - лучше обратитесь в поддержку',
                  en: 'Make sure the version says Latest! Scroll down until you see the version for Windows. If you have any issues, contact support'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/windows/kc/winkcdownload.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image custom-size'
                }
              ]
            },
            {
              number: 2,
              title: {
                ru: 'Установка и первый запуск',
                en: 'Installation and first launch'
              },
              content: {
                ru: 'Запустите установочный файл и следуйте инструкциям. После установки откройте приложение.',
                en: 'Run the installer and follow the instructions. After installation, open the app.'
              },
              warning: {
                title: {
                  ru: '🔧 Windows Defender',
                  en: '🔧 Windows Defender'
                },
                content: {
                  ru: 'Windows Defender может заблокировать установку. Добавьте приложение в исключения, если оно загружено с официального источника.',
                  en: 'Windows Defender may block the installation. Add the app to exceptions if it is downloaded from official source.'
                }
              }
            },
            {
              number: 3,
              title: {
                ru: 'Перейдите по ссылке на подписку в профиле',
                en: 'Follow the subscription link in the profile'
              },
              content: {
                ru: 'Можно использовать пробный период на 30 дней',
                en: 'You can use a 30-day trial period.'
              },
              buttons: [
                {
                  text: {
                    ru: 'Открыть профиль',
                    en: 'Open profile'
                  },
                  url: 'https://diamondvpn.online/profile',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/instructions/getSub.png',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            },
            {
              number: 4,
              title: {
                ru: 'Добавьте подключение',
                en: 'Add connection'
              },
              content: {
                ru: 'После того, как вы нажмете "Моя подписка" у вас откроется сайт внутри телеграм. Вам нужно выбрать устройство (должно быть ПК), выбрать приложение Koala Clash и нажать "Добавить подписку". Приложение автоматически откроется и подписка добавится.',
                en: 'After clicking "My Subscription", a website will open inside Telegram. You need to select device (should be PC), select Koala Clash app and click "Add Subscription". The app will open automatically and the subscription will be added.'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если подписка не добавляется, убедитесь, что вы установили приложение. При возникновении напишите в поддержку:',
                  en: 'If subscription is not added, make sure you installed the app. If issues occur, contact support:'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/windows/kc/winkcaddsub.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            },
            {
              number: 5,
              title: {
                ru: 'Подключитесь к VPN',
                en: 'Connect to VPN'
              },
              content: {
                ru: 'Поздравляю! Если вы на этом шаге, значит вы добавили подписку. Выбирайте нужную локацию и подключайтесь!',
                en: 'Congratulations! If you are at this step, you have added the subscription. Choose your desired location and connect!'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если VPN не работает, обратитесь в поддержку:',
                  en: 'If VPN is not working, contact support:'
                }
              },
              note: {
                title: {
                  ru: 'Ограничения',
                  en: 'Limitations'
                },
                content: {
                  ru: 'У тестового периода ограничение: 5 дней и 15 гигабайт. У платных подписок дается 120 гигабайт в месяц (этого вполне достаточно, чтобы смотреть ютуб по 8+ часов ежедневно в Full HD). Данные ограничения нужны, чтобы недобросовестные пользователи не делились своими подписками со своими друзьями.',
                  en: 'Trial period limitations: 5 days and 15 gigabytes. Paid subscriptions get 120 gigabytes per month (this is enough to watch YouTube for 8+ hours daily in Full HD). These limitations are needed to prevent users from sharing subscriptions with friends.'
                }
              },
              images: [
                {
                  src: 'images/windows/kc/winkcconnect.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            }
          ]
        },
        {
          id: 'windows-happ',
          name: {
            ru: 'Happ',
            en: 'Happ'
          },
          icon: 'HP',
          steps: [
            {
              number: 1,
              title: {
                ru: 'Скачайте Happ',
                en: 'Download Happ'
              },
              content: {
                ru: 'Перейдите на сайт Happ по кнопке и скачайте последнюю версию для Windows:',
                en: 'Go to Happ website via the button and download the latest version for Windows:'
              },
              buttons: [
                {
                  text: {
                    ru: '📲 Ссылка на Happ',
                    en: '📲 Link to Happ'
                  },
                  url: 'https://github.com/happyou/HappWindows/releases',
                  className: 'download-btn'
                }
              ],
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Обязательно у версии должно быть написано Latest! Листайте ниже, пока не увидите версию для Windows. Если что то не получается - лучше обратитесь в поддержку',
                  en: 'Make sure the version says Latest! Scroll down until you see the version for Windows. If you have any issues, contact support'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/windows/happ/winhappdownload.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image custom-size'
                }
              ]
            },
            {
              number: 2,
              title: {
                ru: 'Установка и первый запуск',
                en: 'Installation and first launch'
              },
              content: {
                ru: 'Запустите установочный файл и следуйте инструкциям. После установки откройте приложение.',
                en: 'Run the installer and follow the instructions. After installation, open the app.'
              },
              warning: {
                title: {
                  ru: '🔧 Windows Defender',
                  en: '🔧 Windows Defender'
                },
                content: {
                  ru: 'Windows Defender может заблокировать установку. Добавьте приложение в исключения, если оно загружено с официального источника.',
                  en: 'Windows Defender may block the installation. Add the app to exceptions if it is downloaded from official source.'
                }
              }
            },
            {
              number: 3,
              title: {
                ru: 'Перейдите по ссылке на подписку в профиле',
                en: 'Follow the subscription link in the profile'
              },
              content: {
                ru: 'Можно использовать пробный период на 30 дней',
                en: 'You can use a 30-day trial period.'
              },
              buttons: [
                {
                  text: {
                    ru: 'Открыть профиль',
                    en: 'Open profile'
                  },
                  url: 'https://diamondvpn.online/profile',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/instructions/getSub.png',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            },
            {
              number: 4,
              title: {
                ru: 'Добавьте подключение',
                en: 'Add connection'
              },
              content: {
                ru: 'После того, как вы нажмете "Моя подписка" у вас откроется сайт внутри телеграм. Вам нужно выбрать устройство (должно быть ПК), выбрать приложение Happ и нажать "Добавить подписку". Приложение автоматически откроется и подписка добавится.',
                en: 'After clicking "My Subscription", a website will open inside Telegram. You need to select device (should be PC), select Happ app and click "Add Subscription". The app will open automatically and the subscription will be added.'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если подписка не добавляется, убедитесь, что вы установили приложение. При возникновении напишите в поддержку:',
                  en: 'If subscription is not added, make sure you installed the app. If issues occur, contact support:'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/windows/happ/winhappaddsub.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            },
            {
              number: 5,
              title: {
                ru: 'Подключитесь к VPN',
                en: 'Connect to VPN'
              },
              content: {
                ru: 'Поздравляю! Если вы на этом шаге, значит вы добавили подписку. Выбирайте нужную локацию и подключайтесь!',
                en: 'Congratulations! If you are at this step, you have added the subscription. Choose your desired location and connect!'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если VPN не работает, обратитесь в поддержку:',
                  en: 'If VPN is not working, contact support:'
                }
              },
              note: {
                title: {
                  ru: 'Ограничения',
                  en: 'Limitations'
                },
                content: {
                  ru: 'У тестового периода ограничение: 5 дней и 15 гигабайт. У платных подписок дается 120 гигабайт в месяц (этого вполне достаточно, чтобы смотреть ютуб по 8+ часов ежедневно в Full HD). Данные ограничения нужны, чтобы недобросовестные пользователи не делились своими подписками со своими друзьями.',
                  en: 'Trial period limitations: 5 days and 15 gigabytes. Paid subscriptions get 120 gigabytes per month (this is enough to watch YouTube for 8+ hours daily in Full HD). These limitations are needed to prevent users from sharing subscriptions with friends.'
                }
              },
              images: [
                {
                  src: 'images/windows/happ/winhappconnect.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: 'macos',
      name: {
        ru: 'macOS',
        en: 'macOS'
      },
      icon: 'fab fa-apple',
      apps: [
        {
          id: 'macos-koala',
          name: {
            ru: 'Koala Clash',
            en: 'Koala Clash'
          },
          icon: 'KC',
          steps: [
            {
              number: 1,
              title: {
                ru: 'Скачайте Koala Clash',
                en: 'Download Koala Clash'
              },
              content: {
                ru: 'Перейдите на сайт Koala Clash по кнопке и скачайте последнюю версию для macOS:',
                en: 'Go to Koala Clash website via the button and download the latest version for macOS:'
              },
              buttons: [
                {
                  text: {
                    ru: '📲 Ссылка на Koala Clash',
                    en: '📲 Link to Koala Clash'
                  },
                  url: 'https://github.com/coolcoala/clash-verge-rev-lite/releases',
                  className: 'download-btn'
                }
              ],
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Обязательно у версии должно быть написано Latest! Листайте ниже, пока не увидите версию для macOS. Если что то не получается - лучше обратитесь в поддержку',
                  en: 'Make sure the version says Latest! Scroll down until you see the version for macOS. If you have any issues, contact support'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/macos/kc/mackcdownload.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image custom-size'
                }
              ]
            },
            {
              number: 2,
              title: {
                ru: 'Установка и первый запуск',
                en: 'Installation and first launch'
              },
              content: {
                ru: 'Запустите установочный файл и следуйте инструкциям. После установки откройте приложение.',
                en: 'Run the installer and follow the instructions. After installation, open the app.'
              },
              warning: {
                title: {
                  ru: '🔧 macOS Gatekeeper',
                  en: '🔧 macOS Gatekeeper'
                },
                content: {
                  ru: 'macOS может заблокировать установку. В настройках безопасности разрешите установку из любых источников.',
                  en: 'macOS may block the installation. In security settings, allow installation from any sources.'
                }
              }
            },
            {
              number: 3,
              title: {
                ru: 'Перейдите по ссылке на подписку в профиле',
                en: 'Follow the subscription link in the profile'
              },
              content: {
                ru: 'Можно использовать пробный период на 30 дней',
                en: 'You can use a 30-day trial period.'
              },
              buttons: [
                {
                  text: {
                    ru: 'Открыть профиль',
                    en: 'Open profile'
                  },
                  url: 'https://diamondvpn.online/profile',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/instructions/getSub.png',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            },
            {
              number: 4,
              title: {
                ru: 'Добавьте подключение',
                en: 'Add connection'
              },
              content: {
                ru: 'После того, как вы нажмете "Моя подписка" у вас откроется сайт внутри телеграм. Вам нужно выбрать устройство (должно быть Mac), выбрать приложение Koala Clash и нажать "Добавить подписку". Приложение автоматически откроется и подписка добавится.',
                en: 'After clicking "My Subscription", a website will open inside Telegram. You need to select device (should be Mac), select Koala Clash app and click "Add Subscription". The app will open automatically and the subscription will be added.'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если подписка не добавляется, убедитесь, что вы установили приложение. При возникновении напишите в поддержку:',
                  en: 'If subscription is not added, make sure you installed the app. If issues occur, contact support:'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/macos/kc/mackcaddsub.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            },
            {
              number: 5,
              title: {
                ru: 'Подключитесь к VPN',
                en: 'Connect to VPN'
              },
              content: {
                ru: 'Поздравляю! Если вы на этом шаге, значит вы добавили подписку. Выбирайте нужную локацию и подключайтесь!',
                en: 'Congratulations! If you are at this step, you have added the subscription. Choose your desired location and connect!'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если VPN не работает, обратитесь в поддержку:',
                  en: 'If VPN is not working, contact support:'
                }
              },
              note: {
                title: {
                  ru: 'Ограничения',
                  en: 'Limitations'
                },
                content: {
                  ru: 'У тестового периода ограничение: 5 дней и 15 гигабайт. У платных подписок дается 120 гигабайт в месяц (этого вполне достаточно, чтобы смотреть ютуб по 8+ часов ежедневно в Full HD). Данные ограничения нужны, чтобы недобросовестные пользователи не делились своими подписками со своими друзьями.',
                  en: 'Trial period limitations: 5 days and 15 gigabytes. Paid subscriptions get 120 gigabytes per month (this is enough to watch YouTube for 8+ hours daily in Full HD). These limitations are needed to prevent users from sharing subscriptions with friends.'
                }
              },
              images: [
                {
                  src: 'images/macos/kc/mackcconnect.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            }
          ]
        },
        {
          id: 'macos-happ',
          name: {
            ru: 'Happ',
            en: 'Happ'
          },
          icon: 'HP',
          steps: [
            {
              number: 1,
              title: {
                ru: 'Скачайте Happ',
                en: 'Download Happ'
              },
              content: {
                ru: 'Перейдите на сайт Happ по кнопке и скачайте последнюю версию для macOS:',
                en: 'Go to Happ website via the button and download the latest version for macOS:'
              },
              buttons: [
                {
                  text: {
                    ru: '📲 Ссылка на Happ',
                    en: '📲 Link to Happ'
                  },
                  url: 'https://github.com/happyou/HappMac/releases',
                  className: 'download-btn'
                }
              ],
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Обязательно у версии должно быть написано Latest! Листайте ниже, пока не увидите версию для macOS. Если что то не получается - лучше обратитесь в поддержку',
                  en: 'Make sure the version says Latest! Scroll down until you see the version for macOS. If you have any issues, contact support'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/macos/happ/machappdownload.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image custom-size'
                }
              ]
            },
            {
              number: 2,
              title: {
                ru: 'Установка и первый запуск',
                en: 'Installation and first launch'
              },
              content: {
                ru: 'Запустите установочный файл и следуйте инструкциям. После установки откройте приложение.',
                en: 'Run the installer and follow the instructions. After installation, open the app.'
              },
              warning: {
                title: {
                  ru: '🔧 macOS Gatekeeper',
                  en: '🔧 macOS Gatekeeper'
                },
                content: {
                  ru: 'macOS может заблокировать установку. В настройках безопасности разрешите установку из любых источников.',
                  en: 'macOS may block the installation. In security settings, allow installation from any sources.'
                }
              }
            },
            {
              number: 3,
              title: {
                ru: 'Перейдите по ссылке на подписку в профиле',
                en: 'Follow the subscription link in the profile'
              },
              content: {
                ru: 'Можно использовать пробный период на 30 дней',
                en: 'You can use a 30-day trial period.'
              },
              buttons: [
                {
                  text: {
                    ru: 'Открыть профиль',
                    en: 'Open profile'
                  },
                  url: 'https://diamondvpn.online/profile',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/instructions/getSub.png',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            },
            {
              number: 4,
              title: {
                ru: 'Добавьте подключение',
                en: 'Add connection'
              },
              content: {
                ru: 'После того, как вы нажмете "Моя подписка" у вас откроется сайт внутри телеграм. Вам нужно выбрать устройство (должно быть Mac), выбрать приложение Happ и нажать "Добавить подписку". Приложение автоматически откроется и подписка добавится.',
                en: 'After clicking "My Subscription", a website will open inside Telegram. You need to select device (should be Mac), select Happ app and click "Add Subscription". The app will open automatically and the subscription will be added.'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если подписка не добавляется, убедитесь, что вы установили приложение. При возникновении напишите в поддержку:',
                  en: 'If subscription is not added, make sure you installed the app. If issues occur, contact support:'
                }
              },
              buttons: [
                {
                  text: {
                    ru: 'Написать в поддержку',
                    en: 'Contact support'
                  },
                  url: 'https://t.me/diamondvpnsupport',
                  className: 'telegram-btn'
                }
              ],
              images: [
                {
                  src: 'images/macos/happ/machappaddsub.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            },
            {
              number: 5,
              title: {
                ru: 'Подключитесь к VPN',
                en: 'Connect to VPN'
              },
              content: {
                ru: 'Поздравляю! Если вы на этом шаге, значит вы добавили подписку. Выбирайте нужную локацию и подключайтесь!',
                en: 'Congratulations! If you are at this step, you have added the subscription. Choose your desired location and connect!'
              },
              warning: {
                title: {
                  ru: '⚠️ Важно',
                  en: '⚠️ Important'
                },
                content: {
                  ru: 'Если VPN не работает, обратитесь в поддержку:',
                  en: 'If VPN is not working, contact support:'
                }
              },
              note: {
                title: {
                  ru: 'Ограничения',
                  en: 'Limitations'
                },
                content: {
                  ru: 'У тестового периода ограничение: 5 дней и 15 гигабайт. У платных подписок дается 120 гигабайт в месяц (этого вполне достаточно, чтобы смотреть ютуб по 8+ часов ежедневно в Full HD). Данные ограничения нужны, чтобы недобросовестные пользователи не делились своими подписками со своими друзьями.',
                  en: 'Trial period limitations: 5 days and 15 gigabytes. Paid subscriptions get 120 gigabytes per month (this is enough to watch YouTube for 8+ hours daily in Full HD). These limitations are needed to prevent users from sharing subscriptions with friends.'
                }
              },
              images: [
                {
                  src: 'images/macos/happ/machappconnect.jpg',
                  alt: {
                    ru: 'Описание изображения',
                    en: 'Image description'
                  },
                  className: 'step-image'
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};